<template>
<div class="container">
    <div class="row">
        <!-- <Button @click="handleBackStep" size="small" type="outline" color="grey">
            <ArrowDropdown :rotate="90" /> Voltar
        </Button>
        <div class="col-12 mt-3 pl-0 d-flex align-items-center">
            <h3 class="c-ndarkthree mb-0 break">
                <span class="bold">Dados da empresa</span>
                <span class="c-ndarkthree"> | </span>
                {{ $store.state.register.company.name | formatName }}
            </h3>
            <CompanyTypeStatus :companyType="$store.state.register.company.cnpj.companyType"/>
        </div> -->
        <Button v-if="$store.state.user.userAdm || USER_TYPE_MIXIN.isBackOffice" class="mb-3" @click="handleBackStep" size="small" type="outline" color="grey">
            <ArrowDropdown :rotate="90" /> Voltar
        </Button>
        <RegisterHeader />
        <BoxRegister>
            <div class="col-12 mt-4 mb-2">
                <h4 class="c-ndarkfour bold">
                    Dados gerais da empresa
                </h4>
            </div>
            <!-- <InfoCnpj :info="$store.state.register.company" /> -->
            <div class="col-12 mt-4">
                <el-form :model="company" ref="company" :rules="rules">

                    <div class="row mt-2">
                        <div class="col-6">
                            <el-form-item prop="name">
                                <InputText v-model.lazy="company.name" label="Razão social" placeholder="Razão social" :readonly="$store.state.register.company.name ? true : false"/>
                            </el-form-item>
                        </div>
                        <div class="col-6">
                            <el-form-item prop="cnpj">
                                <InputText v-model.lazy="company.cnpj.cnpj" label="CNPJ" placeholder="00.000.000/0000-00" v-mask="'##.###.###/####-##'" :readonly="$store.state.register.company.cnpj.cnpj ? true : false"/>
                            </el-form-item>
                        </div>
                        <div class="col-6">
                            <el-form-item prop="tradingName">
                                <InputText v-model="company.tradingName" label="Nome fantasia" placeholder="Nome fantasia"/>
                            </el-form-item>
                        </div>
                        <div class="col-6">
                            <el-form-item prop="cnae">
                                <!-- <InputText v-model.lazy="company.cnae" label="Atividade principal" placeholder="Atividade principal" :readonly="$store.state.register.company.cnae"/> -->
                                <label>Atividade principal</label>
                                <el-select v-model="company.cnae" placeholder="Atividade principal" filterable no-match-text="Atividade principal não encontrada" :disabled="$store.state.register.company.cnae ? true : false">
                                    <el-option
                                        v-for="cnae in cnaeListItems"
                                        :key="cnae.cod"
                                        :label="`${cnae.cod} - ${cnae.desc}`"
                                        :value="`${cnae.cod} - ${cnae.desc}`"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-6">
                            <el-form-item prop="openingDate">
                                <label>Data de abertura</label>
                                <!-- <InputText v-model="company.openingDate" label="Data de abertura" placeholder="Data de abertura" v-mask="'##/##/####'" :readonly="$store.state.register.company.openingDate"/> -->
                                <el-date-picker class="overflow-hidden" v-model="company.openingDate" type="date" placeholder="DD/MM/YYYY" format="dd/MM/yyyy" value-format="yyyy-MM-dd" v-mask="'##/##/####'" placement="top" :readonly="$store.state.register.company.openingDate ? true : false"/>
                            </el-form-item>
                        </div>
                    </div>

                    <div v-if="isInvestmentFund">
                        <div class="row mt-2">
                            <div class="col-12 mb-3">
                                <p class="c-ndarkfour medium">Administradora</p>
                            </div>
                            <div class="col-6">
                                <el-form-item prop="adminName">
                                    <InputText v-model="company.adminName" label="Razão Social" placeholder="Razão social da empresa" />
                                </el-form-item>
                            </div>
                            <div class="col-6">
                                <el-form-item prop="adminCnpj">
                                    <InputText v-model.lazy="company.adminCnpj" label="CNPJ" placeholder="00.000.000/0000-00" v-mask="'##.###.###/####-##'" />
                                </el-form-item>
                            </div>
                        </div>

                        <div class="row mt-2">
                            <div class="col-12 mb-3">
                                <p class="c-ndarkfour medium">Gestora</p>
                            </div>
                            <div class="col-6">
                                <el-form-item prop="managerName">
                                    <InputText v-model="company.managerName" label="Razão Social" placeholder="Razão social da empresa" />
                                </el-form-item>
                            </div>
                            <div class="col-6">
                                <el-form-item prop="managerCnpj">
                                    <InputText v-model.lazy="company.managerCnpj" label="CNPJ" placeholder="00.000.000/0000-00" v-mask="'##.###.###/####-##'" />
                                </el-form-item>
                            </div>
                        </div>

                        <div class="row mt-4">
                            <div class="col-12">
                                <label>Quem paga a taxa {{ getWhiteLabel | capitalizeFirstLetter }}?</label>
                                <el-radio :class="getPrimaryColor" v-model="company.cashforceTaxPayer" :label="'sponsor'">Financiadora</el-radio>
                                <el-radio :class="getPrimaryColor" v-model="company.cashforceTaxPayer" :label="'manager'">Gestora</el-radio>
                            </div>
                        </div>
                    </div>

<!--                     <div class="row mt-2">
                        <div class="col-6">
                            <el-form-item prop="registerComplete">
                                <label class="c-ndarkfour regular">Possui cadastro completo?</label>
                                <el-radio :class="getPrimaryColor" v-model="company.registerComplete" label="1">Sim</el-radio>
                                <el-radio :class="getPrimaryColor" v-model="company.registerComplete" label="0">Não</el-radio>
                            </el-form-item>
                        </div>
                    </div> -->

                    <div class="row mt-4">
                        <div class="col-12 mb-3">
                            <p class="c-ndarkfour medium">Contato </p>
                        </div>
                        <div class="col-6">
                            <el-form-item prop="email">
                                <InputText ref="email" v-model="company.email" label="E-mail da empresa" placeholder="email@gmail.com" />
                            </el-form-item>
                        </div>
                        <div class="col-6">
                            <el-form-item prop="phoneNumber">
                                <InputText v-model="company.phoneNumber" label="Telefone comercial" placeholder="(11) 3456-5555" v-mask="['(##) ####-####', '(##) #####-####']" />
                            </el-form-item>
                        </div>
                        <div class="col-6">
                            <el-form-item prop="website">
                                <InputText v-model="company.website" label="Site" placeholder="www.site.com.br" />
                            </el-form-item>
                        </div>
                    </div>

                    <div class="row mt-4">
                        <div class="col-12 mb-3">
                            <p class="c-ndarkfour medium">Conta corrente empresarial</p>
                        </div>
                        <div class="col-4">
                            <!-- <InputText v-model="bankInfo.bank" label="Banco" placeholder="1234345 - Banco Bradesco" /> -->
                            <label>Banco</label>
                            <el-input :class="getPrimaryColor" disabled v-model="bank" placeholder="Banco"/>
                        </div>
                        <div class="col-4">
                            <label>Agência</label>
                            <el-input :class="getPrimaryColor" disabled v-model="bankInfo.agency" placeholder="Agência"/>
                        </div>
                        <div class="col-4">
                            <label>Conta</label>
                            <el-input :class="getPrimaryColor" disabled v-model="bankInfo.account" placeholder="Conta"/>
                        </div>
                        <div class="col-8 mt-3"> 
                            <label>Chave PIX</label> 
                            <el-input :class="getPrimaryColor" disabled v-model="bankInfo.pix" placeholder="CPF/CNPJ, celular, e-mail ou chave aleatória " /> 
                        </div> 
                    </div>

                    <div class="row mt-5">
                        <div class="col-12 mb-3">
                            <p class="c-ndarkfour medium">Informações adicionais</p>
                        </div>
                        <div class="col-6">
                            <el-form-item prop="employeesNumber">
                                <Select v-model="company.employeesNumber" label="Quantidade de funcionários" placeholder="100-200" :items="[{label: '1-10', value: '1-10'},{label: '10-50', value: '10-50'},{label: '50-100', value: '50-100'},{label: '100-200', value: '100-200'}, {label: '+200', value: '+200'}]" />
                            </el-form-item>
                        </div>
                        <div class="col-6">
                            <el-form-item prop="equityCapital">
                                <!-- <InputText v-model="company.equityCapital" label="Capital social" placeholder="R$ 1.000.000,00" v-money="money"/> -->
                                <label>Capital social</label>
                                <el-input :class="getPrimaryColor" v-model="company.equityCapital" placeholder="R$ 1.000.000,00" v-money="money"/>
                            </el-form-item>
                        </div>
                        <!-- <div class="col-6">
                            <el-form-item prop="administrator">
                                <Select v-model="company.administrator" label="Qual empresa administra o fundo?" placeholder="Selecionar empresa" :items="[{ label: 'Empresa A', value: 0}, { label: 'Empresa B', value: 1}]" />
                            </el-form-item>
                        </div>
                        <div class="col-6">
                            <el-form-item prop="hedgeFundService">
                                <Select v-model="company.hedgeFundService" label="Qual é gestora do fundo?" placeholder="Selecionar empresa" :items="[{ label: 'Empresa A', value: 0}, { label: 'Empresa B', value: 1}]" />
                            </el-form-item>
                        </div> -->
                    </div>

                    <div class="row mt-4">
                        <div class="col-12 mb-3">
                            <p class="c-ndarkfour medium">Cobrança</p>
                        </div>
                        <div class="col-4">
                            <el-form-item prop="AdValoremAndFaresTax">
                                <!-- <InputText v-model="company.AdValoremAndFaresTax" label="Taxa sobre o Ad Valorem e Tarifas" placeholder="10%" v-money="numberFloat"/> -->
                                <label>Taxa sobre o Ad Valorem e Tarifas (%)</label>
                                <el-input :class="getPrimaryColor" v-model="company.AdValoremAndFaresTax" placeholder="10%" v-money="numberFloat"/>
                            </el-form-item>
                        </div>
                        <div class="col-3">
                            <el-form-item prop="cancellationFee">
                                <!-- <InputText v-model="company.AdValoremAndFaresTax" label="Taxa sobre o Ad Valorem e Tarifas" placeholder="10%" v-money="numberFloat"/> -->
                                <label>Taxa de cancelamento (R$)</label>
                                <el-input :class="getPrimaryColor" v-model="company.cancellationFee" placeholder="R$ 200,00" v-money="money"/>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>
                <div class="row mt-4">
                    <div class="col-12">
                        <!-- <InputRadio v-model="taxType" label="Qual tipo de taxa aplicar?" :items="['Única', 'Escalonada']" /> -->
                        <label>Qual tipo de taxa aplicar?</label>
                        <el-radio :class="getPrimaryColor" v-model="taxType" :label="0">Única</el-radio>
                        <el-radio :class="getPrimaryColor" v-model="taxType" :label="1">Escalonada</el-radio>
                    </div>
                </div>

                <div class="row mt-4 mb-5" v-if="taxType == 0">
                    <div class="col-3">
                        <!-- <InputText v-model="singleTax" label="Taxa de operação (a.m)" placeholder="0,12%" v-money="numberFloat"/> -->
                        <label>Taxa de operação (a.m)</label>
                        <!-- <el-input :class="getPrimaryColor" ref="sigleTax" v-model.lazy="singleTax" placeholder="0,12%" v-money="numberFloat"/> -->
                        <Money class="input-money" v-model="singleTax" v-bind="operationTaxFloat" :class="incorrectTaxes && singleTax == 0.00 ? 'input-money__error' : ''"/>
                        <h6 class="mt-1 mb-0 password-strength-label regular" :class="incorrectTaxes && singleTax == 0.00 ? 'c-error' : ''">
                            {{ incorrectTaxes && singleTax == 0.00 ? 'Esse valor não pode ser igual 0.00%' : '' }}
                        </h6>
                    </div>
                </div>
                <div class="row d-flex justify-content-center align-items-center mt-1 mb-4" v-else-if="taxType == 1">
                    <div class="col-12">
                        <SponsorTax :errorTaxes="incorrectTaxes" :taxes="taxes" @change="fareRangeOperationTaxes = $event" @changeTaxType="taxType = 0"/>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <p class="c-ndarkfour medium mb-3">Logo da empresa</p>
                        <UploadLogo :previewBackupImage="company.filePreview" :logo="company.logoImgPath" @change="company.logoImgPath = $event" @delete="company.logoImgPath = $event"/>
                    </div>
                </div>

                <div class="row mt-4 mb-4">
                    <div class="col-12">
                        <!-- <InputRadio v-model="taxType" label="Qual tipo de taxa aplicar?" :items="['Única', 'Escalonada']" /> -->
                        <p class="c-ndarkfour medium mb-2">Mostrar dados do financiador na proposta?</p>
                        <el-radio :class="getPrimaryColor" v-model="company.visible" :label="true">Sim</el-radio>
                        <el-radio :class="getPrimaryColor" v-model="company.visible" :label="false">Não</el-radio>
                    </div>
                </div>
                <div class="row mt-5 mb-4">
                    <div class="col-12 mb-2">
                        <p class="c-ndarkfour bold">Emissão de NFe</p>
                    </div>
                    <div class="col-6">
                        <h6 class="c-ndarkfour regular my-2">
                            Qual o regime tributário da empresa?
                        </h6>

                        <el-radio-group v-model="company.taxClassification">
                            <el-radio :class="getPrimaryColor" label="simples">Simples nacional</el-radio>
                            <el-radio :class="getPrimaryColor" label="fidic" >FIDIC</el-radio>
                            <el-radio :class="getPrimaryColor" label="outro">Outro</el-radio>
                        </el-radio-group>
                            
                    </div>
                </div>
                <div class="row mb-4">
                    <!-- <div class="col-12 d-flex align-items-center mt-3">
                        <Button @click="nextStep"> Salvar e continuar </Button :color="getPrimaryColor">
                    </div> -->
                    <RegisterNavigationButtons v-if="$store.state.user.userAdm" @backStep="backStep" @nextStep="nextStep" @saveChange="saveChanges"/>
                </div>
            </div>
        </BoxRegister>
    </div>
    <CancelRegister :dialogVisible="dialogVisible" @closeModal="dialogVisible = $event" @cancelRegister="backStep" @saveChange="saveChanges"/>
</div>
</template>

<script>
import RegisterNavigationButtons from '@/components/register/RegisterNavigationButtons'
//import Trash from '@/components/icons/Trash'
import UploadLogo from '@/components/uploads/UploadLogo'
import RegisterHeader from '@/components/register/RegisterHeader'
//import Delete from '@/components/icons/Delete'
//import Replace from '@/components/icons/Replace'
//import CompanyTypeStatus from '@/components/status/CompanyTypeStatus'
import CancelRegister from '@/components/modals/CancelRegister'
import ArrowDropdown from '@/components/icons/ArrowDropdown'
import BoxRegister from '@/components/box/BoxRegister'
//import InfoCnpj from '@/components/infos/InfoCnpj'
import SponsorTax from '@/components/taxes/SponsorTax'
import updateCompany from '@/api/updateCompany'
import insertTaxes from '@/api/insertTaxes'
import getTaxes from '@/api/getTaxes'
import getBankAccount from '@/api/getBankAccount'
import removeMask from '@/utils/removeMask'
import cnaeList from '@/utils/cnaeList'
import banksList from '@/utils/banksList'
import { VMoney, Money } from 'v-money'
import Vue from 'vue'

const numberFloat = {
    decimal: ',',
    thousands: '.',
    precision: 2,
    suffix: '%'    
}

export default {
    components: {
        //Delete,
        //Replace,
        //Trash,
        UploadLogo,
        //CompanyTypeStatus,
        CancelRegister,
        BoxRegister,
        SponsorTax,
        //InfoCnpj,
        ArrowDropdown,
        Money,
        RegisterHeader,
        RegisterNavigationButtons
    },    
    data() {
        return {
            dialogVisible:false,
            cnaeListItems: cnaeList,
            numberFloat,
            money: {
                ...numberFloat,
                prefix: 'R$ '
            },
            operationTaxFloat: {
                ...numberFloat,
                precision: 3,
            },
            bankInfo: {
                bank: '',
                agency: '',
                account: ''
            },
            company: {
                name: '',
                tradingName: '',
                cnae: '',
                openingDate: '',
                cnpj: {
                    cnpj: ''
                },
                email: '',
                phoneNumber: '',
                website: '',
                employeesNumber: '',
                equityCapital: '',
                AdValoremAndFaresTax: '',
                cancellationFee: '',
                registerComplete: '',
                visible: '',
                adminName: '',
                adminCnpj: '',
                managerName: '',
                managerCnpj: '',
                cashforceTaxPayer: ''
            },
            filePreview: {},
            logo: {},
            taxType: 0,
            singleTax: '',
            fareRangeOperationTaxes: [{
                fareMin: '0',
                fareMax: '1',
                operationTax: 0
            }],
            taxes: [],
            incorrectTaxes: false,
            rules: {
            },
            formValid: false,
            isInvestmentFund: false,

        }
    },
    directives: {
        money: VMoney
    },
    watch: {
        taxType(val) {
            if (val == 0) {
                this.fareRangeOperationTaxes = [{
                    fareMin: '0',
                    fareMax: '1',
                    operationTax: 0
                }]
            } else {
                if (this.taxes.length > 0) {
                    this.fareRangeOperationTaxes = this.taxes
                    return
                }
                this.fareRangeOperationTaxes = [
                    {
                        fareMin: '0',
                        fareMax: '0.5',
                        operationTax: '0'
                    },
                    {
                        fareMin: '0.5001',
                        fareMax: '1',
                        operationTax: '0.0001'
                    }
                ]
            }
        },
        singleTax(val) {
            this.fareRangeOperationTaxes[0].operationTax = (val / 100)
        },
        company: {
            deep: true,
            handler() {
                this.isInvestmentFund = this.validateCnae

                if (!this.$store.state.register.formIsChanged) {
                    this.$store.commit('register/setFormIsChanged', true)
                }                
            }
        },
    },
    computed: {
        bank() {
            const bankEntry = banksList.find(bank => bank.COMPE == this.bankInfo.bank)
            if (bankEntry) {
                return `${bankEntry.COMPE} - ${bankEntry.LongName}`
            } else {
                return ''
            }
        },
        validateCnae() {
            const { cnae } = this.company
            if (cnae) {
                const unmaskedCnae = cnae.replace(/-|\./g, "")
                return unmaskedCnae.slice(0, 5) === "64701"
            }
            return false
        }
    },
    methods: {
        isLogoNotUpdate() {
            const logoOnStore = this.$store.state.register.company.logoImgPath
            if (logoOnStore == this.company.logoImgPath) {
                delete this.company.logoImgPath
            }
        },
        validateForm() {
            this.$refs['user'].validate((valid) => {
                if (valid) {
                    this.formValid = true
                } else {
                    this.formValid = false
                }
            });
        },
        async saveChanges() {
            this.isLogoNotUpdate()
            const unmaskedCompany = {
                ...this.company,
                equityCapital: removeMask(this.company.equityCapital),
                AdValoremAndFaresTax: removeMask(this.company.AdValoremAndFaresTax) / 10000,
                cancellationFee: removeMask(this.company.cancellationFee),
            }
            const result = await updateCompany(this.$route.params.idCNPJ, unmaskedCompany)
            const taxResult = await insertTaxes({ cnpjId: this.$route.params.idCNPJ, fareRangeOperationTaxes: this.fareRangeOperationTaxes })
            if (!taxResult.ok) this.incorrectTaxes = true
            if (result.ok && taxResult.ok) {
                this.$notify({
                    title: 'Dados salvos com sucesso.',
                    message: '',
                    type: 'success',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                })
                this.$store.commit('register/setCompany', this.company)
                this.$store.commit('register/setFormIsChanged', false)
            } else {
                this.$notify({
                    title: 'Opa! Encontramos algum erro.',
                    message: '',
                    type: 'error',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                    customClass: 'error'
                });
            }
        },
        async nextStep() {
            if (this.$route.path.includes('update')) {
                this.$router.push(`/sponsor/update/${this.$route.params.idCNPJ}/1`)
            } else {
                this.$router.push(`/sponsor/register/${this.$route.params.idCNPJ}/1`)
            }
        },
        backStep() {
            if (this.$store.state.user.userAdm || this.USER_TYPE_MIXIN.isBackOffice) {
                const regex = /provider|buyer|sponsor/g
                this.$router.push(`/company/${this.$route.path.match(regex)[0]||'sponsor'}`)
            } else {
                this.$router.push(`/company`)
            }
        },
        handleBackStep() {
            if (this.$store.state.register.formIsChanged) {
                this.dialogVisible = true
            } else {
                this.backStep()
            }
        },
        async getBankAccountInfo() {
            const result = await getBankAccount(this.$route.params.idCNPJ)
            if (result.ok && result.payload.length) {
                const bankAccount = result.payload.find(account => account.mainAccount == 1)
                if (bankAccount) {
                    const { bank, account, agency } = bankAccount
                    this.bankInfo = {
                        bank,
                        account,
                        agency,
                    }
                }              
            }
        }
    },
    async created() {
        this.company = {
            ...this.$store.state.register.company,
            registerComplete: this.$store.state.register.company.cnpj.registerComplete == true ? '1' : '0',
            cashforceTaxPayer: this.$store.state.register.company.cashforceTaxPayer || 'sponsor'
        }
        if (this.$route.path.includes('update')) {
            this.company.AdValoremAndFaresTax = this.company.AdValoremAndFaresTax * 10000
            const result = await getTaxes(this.$route.params.idCNPJ)
            if (result.ok) {
                if (result.payload.length == 1) {
                    this.singleTax =  (result.payload[0].operationTax * 100)
                } else {
                    this.taxes = result.payload
                    this.taxType = 1
                }
            }
        }
        this.getBankAccountInfo()
        this.$store.commit('register/setFormIsChanged', false)
    },
    mounted() {
        Vue.nextTick(() => {
            this.$store.commit('register/setFormIsChanged', false)
        })
    }

}
</script>

<style lang="scss" scoped>

</style>
